<template>
  <div class="baiduQueue">
      <div class="head">
        <img src="/static/index/index7.png" alt="">
        <div class="title">
            <div class="h1">全国大牌培训机构云集</div>
            <div class="h2">理论与实践的结合技能提升100%</div>
        </div>
        <div class="search">
          <div class="s1"><el-cascader placeholder="区域" :options="options" v-model="selectedOptions" @change="handleChangeData" :props="props"></el-cascader></div>
          <div class="s1">
              <img src="/static/index/index11.png" alt="">
              <el-input v-model="search" @keyup.enter.native="getData" placeholder="名称"></el-input>
          </div>
          <div class="s2" @click="getData">查询</div>
      </div>
      </div>
      
      <h1>Training Center</h1>
      <h2>培训中心</h2>
      <div class="box">
          <div @click="jump(item)" v-for="(item,index) in list" :key="index">
              <img :src="item.logoUrl?item.logoUrl:'/static/index/index6.png'" alt="">
              <div class="b1">{{item.orgName}}</div>
              <div class="b2">
                  <img src="/static/index/index9.png" alt="">
                  <div>{{item.province}}{{item.city}}{{item.area}}</div>
              </div>
              <div class="b3" v-if="item.ids">
                  <div class="b131" v-for="(item2,index2) in item.idsList" :key="index2">{{item2}}</div>
              </div>
          </div>
      </div>
      <footer1></footer1>
      <!-- <el-pagination
      background
        layout="prev, pager, next"
        :total="1000">
    </el-pagination> -->
  </div>
</template>

<script>
import Cookie from "js-cookie";
import { regionData } from "element-china-area-data";
if(regionData[0].label=='北京市'){
    regionData.unshift({label:'全部',value:'000000',children:[{label:'全部',value:'000000',children:[{label:'全部',value:'000000'}]}]})
}

export default {
  title: "课程列表",
  data() {
    return {
        options: regionData,
        selectedOptions:[],
        props:{
            value:'label',
            label:'label'
        },
        chooseCity:[],
        brand:'',
        search:'',
        list:[]
    };
  },
  computed: {},
  components: {},
  mounted(){
      this.getData()
  },
  methods: {
      jump(e){
          this.$router.push({
              path:'/collegeDetail',
              query:{
                  id:e.oid
              }
          })
      },
      handleChangeData(value) {
          if(value[0]=="全部"){
              this.chooseCity=[]
              this.selectedOptions=[]
          }else{
              this.chooseCity=value
          }
          this.getData()
    },
    getData() {
      let obj={
            crud:2,
            orgaJson:JSON.stringify({
                city:this.chooseCity.length==0?null:this.chooseCity[1]!='市辖区'?this.chooseCity[1]:this.chooseCity[0],
                ids:this.brand || null,
                orgName:this.search || null,
                typeId:1
            })
        }
        this.$axios.post('/do_oper_orga', this.$qs.stringify(obj)).then(res => {
            this.list=res.data.data
            for(let i=0;i<this.list.length;i++){
                this.list[i].idsList=this.list[i].ids.split(',')
                if(this.list[i].idsList.length>3){
                    this.list[i].idsList.splice(3,this.list[i].idsList.length-3)
                }
            }
        })
    },
  }
};
</script>  
<style lang="scss" scoped>
.baiduQueue{
  width: 100%;
  height: 100%;
  overflow-y: auto;
//   display: flex;
//   flex-direction: column;
//   padding-bottom: 50px;
  .head{
    width: 100%;
    height: 470px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &>img{
        width: 100%;
        height: 100%;
        position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }
    .title{
        width: 1200px;
        z-index: 1;
        .h1{
            font-size: 50px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            margin-bottom: 44px;
        }
        .h2{
            font-size: 30px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #FFFFFF;
            width: 240px;
        }
    }
    .search{
      width: 1200px;
      height: 135px;
    background: #85A9CD;
    border-radius: 6px;
    position: absolute;
    left: 50%;
    top: 377px;
    transform: translate(-50%,0);
    display: flex;
    align-items: center;
    justify-content: center;
    .s1{
        width: 382px;
        height: 66px;
        border-radius: 6px;
        border: 3px solid #FFFFFF;
        margin-right: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        /deep/ .el-input__inner{
            border: none;
            background: transparent;
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            &::placeholder {
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            }
        }
        /deep/ .el-input__icon{
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
        }
        &>img{
            width: 24px;
            height: 24px;
        }
        &>.el-input{
            width: 60%;
        }
        
        
    }
    .s2{
        width: 222px;
        height: 66px;
        background: #FFFFFF;
        border-radius: 6px;
        text-align: center;
        line-height: 66px;
        font-size: 20px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #0457AD;
    }
  }
  }
  
  h1{
      font-size: 40px;
    font-family: BanglaMN;
    color: #999999;
    text-align: center;
    margin-top: 73px;
  }
  h2{
      font-size: 40px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #666666;
        text-align: center;
        margin-bottom: 50px;
  }
  .box{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      &>div{
          width: 370px;
        height: 408px;
        background: #FFFFFF;
        margin-right: 45px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        &>img{
            width: 130px;
            height: 130px;
            margin-bottom: 38px;
        }
        .b1{
            font-size: 24px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #333333;
            text-align: center;
            margin-bottom: 20px;
        }
        .b2{
            display: flex;
            align-items: center;
            margin-bottom: 19px;
            img{
                width: 18px;
                height: 18px;
            }
            div{
                font-size: 24px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #999999;
                margin-left: 3px;
            }
        }
        .b3{
            display: flex;
            div{
                width: 90px;
                height: 32px;
                border-radius: 6px;
                border: 1px solid #0457AD;
                text-align: center;
                line-height: 32px;
                font-size: 20px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #0457AD;
                margin-right: 10px;
            }
        }
      }
      &>div:nth-child(3n){
          margin-right: 0;
      }

  }
}
.el-pagination{
    text-align: center;
    margin-top: 36px;
    /deep/ .el-pager li,/deep/ .btn-next,/deep/ .btn-prev{
        background: transparent;
    }
    /deep/ .el-pager li:not(.disabled).active{
        border-radius: 50%;
        background: #88C0F8;
    }
}
</style>  


// WEBPACK FOOTER //
// src/pages/college/index.vue